module.exports = __webpack_public_path__ + "static/media/notification.35bf742f.svg";